import { BadgeCheck } from 'lucide-react'

const SkillsCard = ({skills, maxCount} : {skills: string[], maxCount: number}) => {
  return (
    <div className="glass-morphism rounded-xl p-6 animate-fade-in mb-8">
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {skills?.slice(0, maxCount).map((skill) => (
        <div key={skill} className="flex items-center space-x-2 py-1">
          <BadgeCheck className="h-5 w-5 text-teal" />
          <span className="text-gray-300">{skill}</span>
        </div>
      ))}
    </div>
  </div>
  )
}

export default SkillsCard